// extracted by mini-css-extract-plugin
export default {"customOption":"customOptionRenderer_customOption__SmNH4","disabled":"customOptionRenderer_disabled__MR6r6"};